import queryString from 'query-string';
const { stringifyUrl } = queryString;
export const DID_APP_SCHEMA = 'portkey.finance';
export const V1_DID_APP_SCHEMA = 'portkey.did';
export var SCHEME_ACTION;
(function (SCHEME_ACTION) {
    SCHEME_ACTION["login"] = "login";
    SCHEME_ACTION["linkDapp"] = "linkDapp";
    SCHEME_ACTION["addContact"] = "addContact";
    SCHEME_ACTION["addGroup"] = "addGroup";
})(SCHEME_ACTION || (SCHEME_ACTION = {}));
export const formatScheme = ({ scheme, domain, action, custom, version }) => {
    let _scheme = scheme || DID_APP_SCHEMA;
    if (version === 'v1' && !scheme)
        _scheme = V1_DID_APP_SCHEMA;
    return stringifyUrl({
        url: `${_scheme}://${domain}/${action}`,
        query: custom,
    }, { encode: true });
};
